import { render, staticRenderFns } from "./dispatcher.vue?vue&type=template&id=aa73d7e8&scoped=true"
import script from "./dispatcher.vue?vue&type=script&lang=js"
export * from "./dispatcher.vue?vue&type=script&lang=js"
import style0 from "./dispatcher.vue?vue&type=style&index=0&id=aa73d7e8&lang=scss&scoped=true"
import style1 from "./dispatcher.vue?vue&type=style&index=1&id=aa73d7e8&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa73d7e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa73d7e8')) {
      api.createRecord('aa73d7e8', component.options)
    } else {
      api.reload('aa73d7e8', component.options)
    }
    module.hot.accept("./dispatcher.vue?vue&type=template&id=aa73d7e8&scoped=true", function () {
      api.rerender('aa73d7e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systems/dispatcher.vue"
export default component.exports